import { createAsyncThunk } from '@reduxjs/toolkit';

import { AppDispatch, RootState } from './types.ts';

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
}>();
